import React, { useState, useEffect, useRef } from "react";
import { downloadUrl } from "../Services/Configuration";
import KpiService from "../Services/KpiService";
import { store } from "../App";

export default function NotificationBanner(props) {
  const marqueeMessages = (() => {
  const raw = props.marqueeMessages;
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  try { return JSON.parse(raw); } catch { return []; }
})();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused]         = useState(false);
  const [animClass, setAnimClass]       = useState("d5-enter");
  const timerRef = useRef(null);
  useEffect(() => {
    if (marqueeMessages.length === 0 || isPaused) return;
    timerRef.current = setInterval(() => goTo("next"), 4000);
    return () => clearInterval(timerRef.current);
  }, [marqueeMessages.length, isPaused, currentIndex]);

  const goTo = (direction) => {
    /* slide old message out upward, then swap */
    setAnimClass(direction === "next" ? "d5-exit-up" : "d5-exit-down");
    setTimeout(() => {
      setCurrentIndex((prev) =>
        direction === "next"
          ? (prev + 1) % marqueeMessages.length
          : (prev - 1 + marqueeMessages.length) % marqueeMessages.length
      );
      setAnimClass(direction === "next" ? "d5-enter" : "d5-enter-prev");
    }, 220);
  };

  const handlePrev = () => { clearInterval(timerRef.current); goTo("prev"); };
  const handleNext = () => { clearInterval(timerRef.current); goTo("next"); };

  /* ── Icon ── */
  const getIcon = (text = "") => {
    if (/approved/i.test(text))                  return "✅";
    if (/forwarded/i.test(text))                 return "📤";
    if (/updated/i.test(text))                   return "✏️";
    if (/notification|initial|save/i.test(text)) return "📋";
    if (/download|format|upload/i.test(text))    return "📥";
    if (/meeting|schedule/i.test(text))          return "📅";
    if (/support|helpdesk/i.test(text))          return "🎧";
    if (/pending|entries|kpi/i.test(text))       return "📊";
    if (/deadline|last date/i.test(text))        return "⏰";
    if (/verify|officer/i.test(text))            return "✅";
    return "📌";
  };

  /* ── Tag label + CSS class ── */
  const getTag = (text = "") => {
    if (/approved/i.test(text))                  return { label: "Approved",   cls: "nbtag-approved"  };
    if (/forwarded/i.test(text))                 return { label: "Forwarded",  cls: "nbtag-forwarded" };
    if (/updated/i.test(text))                   return { label: "Updated",    cls: "nbtag-updated"   };
    if (/notification|initial|save/i.test(text)) return { label: "Saved",      cls: "nbtag-saved"     };
    if (/download|format/i.test(text))           return { label: "Downloads",  cls: "nbtag-download"  };
    if (/meeting|schedule/i.test(text))          return { label: "Schedule",   cls: "nbtag-schedule"  };
    if (/support|helpdesk/i.test(text))          return { label: "Support",    cls: "nbtag-support"   };
    if (/pending|entries/i.test(text))           return { label: "KPI Status", cls: "nbtag-kpi"       };
    if (/deadline|last date/i.test(text))        return { label: "Deadline",   cls: "nbtag-deadline"  };
    if (/verify|officer/i.test(text))            return { label: "Action",     cls: "nbtag-action"    };
    return { label: "Notice", cls: "nbtag-notice" };
  };

  /* ── Highlight key terms in description ── */
  // const highlightText = (text = "") => {
  //   const parts = text.split(
  //     /(\bFY\s*\d{4}-\d{2,4}\b|\b(?:January|February|March|April|May|June|July|August|September|October|November|December|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\b|\bMonthly\b|\bHalf Yearly\b|\bQuarterly\b|\bAnnually\b|\bDistrict Officer\b|\w+\s+District\b|\w+\s+Mandal\b|\d{1,3}(?:,\d{3})*\b|\b\d{1,2}\s+\w+\s+\d{4}\b|[\w.+-]+@[\w.-]+\.[a-z]{2,})/gi
  //   );
  //   return parts.map((part, i) =>
  //     /Mandal|FY\s*\d|Officer|Monthly|Quarterly|Annually|Half Yearly|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC|January|February|March|April|May|June|July|August|September|October|November|December|\d|@/i.test(part)
  //       ? <strong key={i} className="d5-highlight">{part}</strong>
  //       : part
  //   );
  // };
const HIGHLIGHT_REGEX =
  /\b(?:FY\s+\d{4}-\d{2,4}|(?:January|February|March|April|May|June|July|August|September|October|November|December|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|Monthly|Half\s+Yearly|Quarterly|Annually|District\s+Officer|HOD|[A-Za-z0-9_]+\s+(?:District|Mandal)|\d{1,3}(?:,\d{3})*|\d{1,2}\s+[A-Za-z]+\s+\d{4}|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})\b/gi;

const highlightText = (text = "") => {
  const parts = text.split(new RegExp(`(${HIGHLIGHT_REGEX.source})`, "gi"));

  return parts.map((part, i) => {
    const shouldHighlight =
      /^(?:FY\s+\d{4}-\d{2,4}|(?:January|February|March|April|May|June|July|August|September|October|November|December|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|Monthly|Half\s+Yearly|Quarterly|Annually|District\s+Officer|HOD|[A-Za-z0-9_]+\s+(?:District|Mandal)|\d{1,2}\s+[A-Za-z]+\s+\d{4}|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})$/i.test(
        part
      );

    return shouldHighlight ? (
      <strong key={i} className="d5-highlight">
        {part}
      </strong>
    ) : (
      part
    );
  });
};
  if (marqueeMessages.length === 0) return null;

  const msg         = marqueeMessages[currentIndex];
  const subjectText = msg?.subject     || msg?.message || msg?.notice || msg?.text || (typeof msg === "string" ? msg : "");
  const descText    = msg?.subjectDesc || msg?.desc    || msg?.message || msg?.notice || msg?.text || (typeof msg === "string" ? msg : "");
  const icon        = getIcon(subjectText);
  const { label, cls } = getTag(subjectText);


 const handleDownload = async (fileName) => {
  store.dispatch({ type: "SHOW_SPINNER" });
  try {
    let params = {
          "username": localStorage.getItem("fileuserid"),
    "password": localStorage.getItem("filepassword")
    }
    const tokenResponse = await KpiService.downloadtoken(params);


    const token = tokenResponse.data[0]?.Access_token?.access_token;
console.log("Token:", token);
    // Call download API with token
   const response = await KpiService.downloadFile(fileName, token);

    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    // link.download = fileName;
    const downloadName = fileName.split("/").pop();
link.download = downloadName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
  }
  finally {
    store.dispatch({ type: "HIDE_SPINNER" });
  }
};
  return (
    <div className="d5-bar">

      {/* ── Notifications badge ── */}
      <div className="d5-badge">
        <span className="d5-badge-dot" />
        <span>
          <img
            className="marquee-new-icon"
            src="../images/notification.png"
            width="25px"
            alt="new"
            style={{ position: "relative", zIndex: 2, marginRight: "2px" }}
          />
          Notifications
        </span>
      </div>

      {/* ── Message stage — overflow hidden so slide is clipped ── */}
      <div
        className="d5-stage"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* key forces React to remount so animation retriggers on every change */}
        <div className={`d5-item ${animClass}`} key={currentIndex}>

          {/* icon box */}
          {/* <div className="d5-icon-wrap" aria-hidden="true">
            <span className="d5-icon-emoji">{icon}</span>
          </div> */}

          
          <div className="d5-body">

            <div className="d5-title-row">
  <span className={`d5-nbtag ${cls}`}>
    <span className="d5-nbtag-emoji">{icon}</span>
    {label}
  </span>
  <span className="d5-subject">{subjectText}</span>
</div>
            {/* <div className="d5-title-row">
              <span className={`d5-nbtag ${cls}`}>{label}</span>
              <span className="d5-subject">{subjectText}</span>
            </div> */}

            
            <div className="d5-bot">{highlightText(descText)}</div>

          </div>

  

{msg?.dept_notification_files && (
  <>
    <div className="d5-dl-sep" />
    <a
    //   href={ msg?.dept_notification_files 
    // ? `https://housingapi.dev.nidhi.apcfss.in/dmsHousing/file/download?folder=Housing/SwarnaAndhra/DeptNotificationsFiles&file=${msg.dept_notification_files}` 
    // : null}
     href="#"
      className="d5-dl-btn"
      title={msg.dept_notification_files}
      download
       onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    handleDownload(msg.dept_notification_files);
  }}
      // onClick={(e) => e.stopPropagation()}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 3v13M7 11l5 5 5-5" />
        <path d="M5 20h14" />
      </svg>
      <span className="d5-dl-adot" />
    </a>
  </>
)}
        </div>

        {/* {isPaused && <span className="d5-paused-badge">Paused</span>} */}
      </div>

      {/* ── Counter ── */}
      <span className="d5-counter">
        {currentIndex + 1}/{marqueeMessages.length}
      </span>

      {/* ── Arrows ── */}
      <div className="d5-nav-arrows">
        <button className="d5-arrow-btn" onClick={handlePrev} aria-label="Previous" title="Previous">‹</button>
        <button className="d5-arrow-btn" onClick={handleNext} aria-label="Next"     title="Next">›</button>
      </div>

    </div>
  );
}
